import React from 'react';
import { Link } from 'react-router-dom';
import {
  Linkedin, Facebook, Instagram, Youtube,
  MapPin, Phone, Mail, Clock, Globe,
} from 'lucide-react';
import logoMCE from '../assets/logo.png';
import WhatsAppIcon from './WhatsAppIcon';
// ============ MENUS ============
const SOLUTIONS = [
  { label: 'SaaS & Plateformes', to: '/solutions-digitales/saas-logiciels#services-offerts' },
  { label: 'Logiciels métiers & CRM', to: '/solutions-digitales/saas-logiciels#approche-technique' },
  { label: 'Applications web & mobiles', to: '/solutions-digitales/sites-plateformes#notre-approche' },
  { label: 'Sites web & e-commerce', to: '/solutions-digitales/sites-plateformes#landing-page' },
  { label: 'Hébergement & Infrastructure', to: '/solutions-digitales/hebergement-securite#tarifs-hebergement' },
  { label: 'Sécurité & Maintenance', to: '/solutions-digitales/hebergement-securite#tarifs-maintenance' },
];

const TALENTS = [
  { label: 'Formations professionnelles', to: '/talents-rh/academy#catalogue' },
  { label: 'Recrutement & Placement', to: '/talents-rh/recrutement#nos-services' },
  { label: 'Accompagnement RH', to: '/talents-rh/accompagnement-rh#nos-interventions' },
  { label: 'Leadership & Management', to: '/talents-rh' },
  { label: 'Coaching & Développement', to: '/talents-rh/academy#notre-philosophie' },
];

const ACCOMP_EVENTS = [
  { label: 'Accompagnement stratégique', to: '/accompagnement-evenements/accompagnement#axes-accompagnement' },
  { label: 'Team Bulding & networking', to: '/accompagnement-evenements/networking#notre-intention' },
  { label: 'Networking & Impact', to: '/accompagnement-evenements' },
  { label: 'Événementiel international', to: '/accompagnement-evenements/evenementiel' },
];

const SOCIAL_LINKS = [
  { Icon: Linkedin, url: 'https://www.linkedin.com/company/mce-management-communication-event/', label: 'LinkedIn' },
  { Icon: Facebook, url: 'https://www.facebook.com/mce.monde', label: 'Facebook' },
  { Icon: Instagram, url: 'https://www.instagram.com/mce_group1/', label: 'Instagram' },
  { Icon: Youtube, url: 'https://www.youtube.com/@MCEAgency', label: 'YouTube' },
];

// ============ COMPOSANT ============
export default function Footer() {
  return (
    <>
     
{/* ===================== FOOTER ===================== */}
      <footer className="bg-slate-900 text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-10 pb-8">
          <div className="footer-columns grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-10">
            {/* ---------- Brand column ---------- */}
            <div>
              <div className="mb-4 -mt-5 -ml-5 overflow-hidden">
                <img
                  src={logoMCE}
                  alt="MCE Sénégal"
                  className="h-36 w-56 object-cover object-center brightness-125"
                />
              </div>
              <p className="text-[13px] text-gray-300 leading-relaxed mb-5">
                Construisons ensemble les solutions numériques, humaines et
                événementielles qui transforment vos idées en succès durables.
              </p>
              {/* Social Icons */}
              <div className="flex items-center gap-3">
                {SOCIAL_LINKS.map(({ Icon, url, label }, i) => (
                  <a
                    key={i}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center transition-all duration-300 hover:bg-blue-600 hover:scale-110"
                  >
                    <Icon className="w-4 h-4 text-white" />
                  </a>
                ))}
              </div>
            </div>

            {/* ---------- Catégories ---------- */}
            <FooterColumn title="SOLUTIONS NUMÉRIQUES" items={SOLUTIONS} />
            <FooterColumn title="TALENTS & RH" items={TALENTS} />
            <FooterColumn title="ACCOMPAGNEMENT & ÉVÉNEMENTS" items={ACCOMP_EVENTS} />

            {/* ---------- Contact column ---------- */}
            <div className="footer-contact sm:col-span-2 lg:col-span-1">
              <h4 className="text-[11px] tracking-[0.18em] font-bold mb-5 text-white uppercase whitespace-nowrap">
                Contact
              </h4>
              <ul className="space-y-4 text-[13px] text-gray-300">
                <li className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-blue-500" />
                  <span>Dakar, Sénégal</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex flex-col gap-1">
                    <a href="tel:+221338200936" aria-label="Appeler le +221 33 820 09 36" className="flex items-center gap-2 hover:text-blue-500 transition-colors">
                      <Phone aria-hidden="true" className="w-4 h-4 shrink-0 text-blue-500" />
                      <span>+221 33 820 09 36</span>
                    </a>
                    <a href="https://wa.me/33698681150" target="_blank" rel="noopener noreferrer" aria-label="Écrire sur WhatsApp au +33 6 98 68 11 50" className="footer-whatsapp-number flex items-center gap-2 transition-colors">
                      <WhatsAppIcon className="w-4 h-4 shrink-0" />
                      <span>+33 6 98 68 11 50</span>
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0 text-blue-500" />
                  <a href="mailto:mceproagency@gmail.com" className="hover:text-blue-500 transition-colors">
                    mceproagency@gmail.com
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <Clock className="w-4 h-4 mt-0.5 shrink-0 text-blue-500" />
                  <span>Lun - Ven : 9h00 - 18h00</span>
                </li>
                <li className="flex items-start gap-3">
                  <Globe className="w-4 h-4 mt-0.5 shrink-0 text-blue-500" />
                  <span className="text-[12px]">France · Sénégal · Maroc</span>
                </li>
              </ul>
            </div>
          </div>

          {/* ===================== FOOTER BOTTOM ===================== */}
          <div className="footer-legal-bar border-t border-slate-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-[12px] text-gray-400">
            <span>© 2024 MCE GROUP – Tous droits réservés.</span>
            <div className="flex items-center gap-6">
              <Link to="/politique-de-confidentialite" className="hover:text-blue-500 transition-colors">
                Politique de confidentialité
              </Link>
              <Link to="/conditions-generales-de-vente" className="hover:text-blue-500 transition-colors">
                Conditions Générales de Vente
              </Link>
              <button type="button" className="hover:text-blue-500 transition-colors" onClick={() => window.dispatchEvent(new Event('mce:open-cookie-settings'))}>
                Gérer mes cookies
              </button>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

// ============ SOUS-COMPOSANT ============
function FooterColumn({ title, items }) {
  return (
    <div>
      <h4 className="text-[11px] tracking-[0.15em] font-bold mb-5 text-white uppercase whitespace-nowrap">
        {title}
      </h4>
      <ul className="space-y-3 text-[13px] text-gray-300">
        {items.map((item) => (
          <li key={item.label}>
            <Link
              to={item.to}
              className="transition-colors duration-300 hover:text-blue-500 hover:translate-x-1 inline-block"
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
